import React from "react";
import { array, object, bool, string } from "prop-types";
import { useMediaQuery } from "react-responsive";

import Organism1 from "./Organism1";
import Organism2 from "./Organism2";
import CustomStoryCard4 from "../../../molecules/CustomStoryCard4";

import "./row2.m.css";

const Row2 = ({ stories, liveBlogStory, updatedFont, publisherLang, src }) => {
  const isDesktop = useMediaQuery({
    query: "(min-device-width: 1264px)"
  });

  return (
    <div styleName="base">
      <div>
        <Organism1
          stories={!isDesktop ? stories.splice(0, 4) : stories.splice(0, 3)}
          updatedFont={updatedFont}
          publisherLang={publisherLang}
          src="fourteen-stories-3ad-1-widget"
          liveBlogStory={liveBlogStory}
        />
        {stories.length > 0 && <Organism2 stories={stories.splice(0, 6)} updatedFont={updatedFont} src={src} />}
      </div>
      {stories.length > 0 && (
        <div styleName="two-stories-wrapper">
          {stories.splice(0, 2).map((story, index) => (
            <CustomStoryCard4
              story={story.story}
              key={index}
              headlineType={37}
              showStoryMetaInfo={true}
              updatedFont={updatedFont}
            />
          ))}
        </div>
      )}
    </div>
  );
};

Row2.propTypes = {
  stories: array.isRequired,
  updatedFont: bool,
  src: string,
  publisherLang: string,
  liveBlogStory: object
};

export default Row2;
